import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { PersonasService } from 'src/app/servicios/personas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ServiceService } from 'src/app/servicios/service.service';
import { Subject } from 'rxjs';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { Mensajes } from 'src/app/Class/mensajes';
import { Loading } from 'src/app/Class/Loading';
declare var $: any;

@Component({
  selector: 'app-listado',
  templateUrl: './listado.component.html',
  styleUrls: ['./listado.component.css']
})
export class ListadoComponent implements OnInit, OnDestroy {

  public dtTrigger: Subject<any> = new Subject();
  public dtOptions: DataTables.Settings = Object.assign({}, DTConfig.dtConf);
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  public viewImage = null;
  public personas: any = [];
  public formpersona: FormGroup;
  public tiposdocumentos: any = [];
  id: number;
  index: number;

  constructor(private personaService: PersonasService, private serviceService: ServiceService, private fb: FormBuilder,
              public loading: Loading) {
                this.loading.estado = true;

                this.formpersona = this.fb.group({
      nombre: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(149)]],
      apellido: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(149)]],
      idtipo_documento: [, Validators.required],
      documento: [],
      direccion: [],
      telefono: [],
      email: [, Validators.email],
      foto: [],
      id: []
    });

                this.personaService.getListado().subscribe(data => {
      this.personas = data['listado'];
      this.tiposdocumentos = data['tiposdocumentos'];
      this.dtTrigger.next();
      this.loading.estado = false;
    },
    err => {  this.loading.estado = false; }
    );
  }

  ngOnInit() { }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      const reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed
        this.viewImage = event['target']['result'];
      };
      this.formpersona.get('foto').setValue(file);
    }
  }

  nuevaPersona() {
    this.viewImage = null;
    this.formpersona.reset();
    this.index = null;
    // this.persona.get('id').setValue(-1);
    $('#ModalPersona').modal({ backdrop: 'static', keyboard: true, show: true });

  }

  guardarPersona() {
    this.loading.estado = true;
    this.personaService.GuardarPersona(this.formpersona.value)
      .subscribe(data => {
        if (data['success']) {
          if (this.index != null) {
            this.personas[this.index] = data['respuesta'];
          } else {
            this.personas.push(data['respuesta']);
          }
          this.viewImage = null;
          this.rerender();
          $('#ModalPersona').modal('hide');
          Swal.fire({ type: 'success', title: 'Guardado exitoso', showConfirmButton: false, timer: 1500 });
          } else {
            Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
          }
        this.loading.estado = false;
      });
  }

  editar(datos, index) {
    this.index = index;
    this.viewImage =  datos['foto'] ? this.serviceService.server +  datos['foto'] : null;
                                                                                              // tslint:disable-next-line: forin
    for (const atributos in this.formpersona.value) {
      this.formpersona.get(atributos).setValue(datos[atributos]);
    }
    $('#ModalPersona').modal({ backdrop: 'static', keyboard: true, show: true });
  }

  cambiarEstado(id, index) {

    this.index = index;

    Swal.fire({
    title: Mensajes.cambioestado.titulo,
    text: Mensajes.cambioestado.cuerpo,
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Cambiar',
    reverseButtons: true,
    }).then((result) => {
    if (result.value) {
      this.personaService.cambiarEstado(id).subscribe(data => {
        if ( data ['success']) {
          this.personas[this.index] = data['respuesta'];
          this.rerender();
          Swal.fire( Mensajes.cambioestado.respuesta, Mensajes.cambioestado.resultado, 'success' );
        } else {
          Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
        }
      });
    }
  });
  }

  verDetalle(datos) {

    this.viewImage =  datos['foto'] ? this.serviceService.server +  datos['foto'] : null;
                                                                                              // tslint:disable-next-line: forin
    for (const atributos in this.formpersona.value) {
      this.formpersona.get(atributos).setValue(datos[atributos]);
    }
    $('#ModalDetalle').modal({ backdrop: 'static', keyboard: true, show: true });

  }

  public getError(controlName: string): string {
    let error = '';
    const control = this.formpersona.get(controlName);
    if (control.touched && control.errors != null) {
      error = JSON.stringify(control.errors);
    }
    return error;
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

}
